import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainWrapperComponent } from './main-wrapper/main-wrapper.component';
import { AuthGuard } from 'src/app/services/auth.guard';

const mainRoutes: Routes = [
  {
    path: 'evo',
    loadChildren: () => import('../evo/evo.module').then((m) => m.EvoModule),
  },
  {
    path: 'crypto-credential-sending',
    loadChildren: () =>
      import('../crypto-credential-sending/crypto-credential-sending.module').then(
        (m) => m.CryptoCredentialSendingModule
      ),
  },
  {
    path: 'crypto-card',
    loadChildren: () =>
      import('../crypto-card/crypto-card.module').then((m) => m.CryptoCardPageModule),
  },
  {
    path: 'crypto-credential',
    loadChildren: () =>
      import('../crypto-credential/crypto-credential.module').then((m) => m.CryptoCredentialModule),
  },
  // { path: '', pathMatch: 'full', redirectTo: '/' },
  {
    path: '',
    loadChildren: () => import('../landing/landing.module').then((m) => m.LandingModule),
  },
  {
    path: 'about-us',
    loadChildren: () => import('../about-us/about-us.module').then((m) => m.AboutUsModule),
  },
  {
    path: 'news',
    loadChildren: () => import('../news/news.module').then((m) => m.NewsModule),
  },
  {
    path: 'faq',
    loadChildren: () => import('../faq/faq.module').then((m) => m.FaqModule),
  },
  {
    path: 'markets',
    loadChildren: () => import('../search/search.module').then((m) => m.SearchModule),
  },
  {
    path: 'trades',
    loadChildren: () => import('../markets/markets.module').then((m) => m.MarketsModule),
  },
  {
    path: 'admin-intebix',
    loadChildren: () => import('../../admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'user-settings',
    canActivate: [AuthGuard],
    loadChildren: () => import('../profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'fiat-transactions',
    loadChildren: () =>
      import('../fiat-transactions/fiat-transactions.module').then((m) => m.FiatTransactionsModule),
  },
  {
    path: 'wallets',
    loadChildren: () => import('../wallets/wallets.module').then((m) => m.WalletsModule),
  },
  {
    path: 'p2p',
    loadChildren: () => import('../p2p/p2p.module').then((m) => m.P2PModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('../auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'technodom-bonuses',
    loadChildren: () =>
      import('../technodom-bonuses/technodom-bonuses.module').then((m) => m.TechnodomBonusesModule),
  },
  {
    path: 'platform-info',
    loadChildren: () =>
      import('../platform-info/platform-info.module').then((m) => m.PlatformInfoModule),
  },
  {
    path: 'restricted-countries',
    loadChildren: () =>
      import('../restricted-countries/restricted-countries.module').then(
        (m) => m.RestrictedCountriesModule
      ),
  },
  { path: '**', redirectTo: '/markets' },
];

const routes: Routes = [{ path: '', component: MainWrapperComponent, children: mainRoutes }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainWrapperRoutingModule {}
